import { memo } from "react";
import "./Popup.scss";

export const ConfirmPopup = memo(
  ({
    onConfirm,
    onCancel,
    title,
    message,
    confirmText,
    cancelText,
    icon,
    extraClass,
  }: {
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    icon: string;
    extraClass?: string;
  }) => {
    return (
      <div className="modal-overlay" onClick={onCancel}>
        <div
          className={`modal ${extraClass}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`modal_container modal_container--small`}>
            <div className="modal-header">
              {icon && (
                <div className="popup-icon">
                  {icon && <i className={`f-icon ${icon}`}></i>}
                </div>
              )}
            </div>

            <div className="modal-body">
              <h3>{title}</h3>
              <p>{message}</p>
            </div>

            <div className="modal-footer">
              <div className="cta cta--block">
                <button className="btn btn-red " onClick={onConfirm}>
                  {confirmText}
                </button>
                <button className="btn btn-link-dark" onClick={onCancel}>
                  {cancelText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

ConfirmPopup.displayName = "ConfirmPopup";
